import React, { memo } from 'react';

import BadgeCDS from '@sharedCR/coreDesignSystem/BadgeCDS';
import PropTypes from 'prop-types';

import {
  getDisplayValue,
  getStatusBadgeColor,
  hasDisplayValue,
} from '../../SnapdocsClosingSection.utils';

const SnapdocsStatusBadge = ({ status }) => {
  if (!hasDisplayValue(status)) {
    return getDisplayValue(status);
  }

  return <BadgeCDS colorVariant={getStatusBadgeColor(status)} value={getDisplayValue(status)} />;
};

SnapdocsStatusBadge.propTypes = {
  status: PropTypes.string,
};

export default memo(SnapdocsStatusBadge);
